import { Module } from "vuex";
import { userManagementGetters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";
import { UserManagementState, UserDetails } from "./types";
import { RootState } from "@/store/types";
import { getDefaultState } from "./state";

export const state: UserManagementState = getDefaultState();

const namespaced: boolean = true;

export const userManagement: Module<UserManagementState, RootState> = {
	namespaced,
	state,
	getters: userManagementGetters,
	actions,
	mutations
};